import { type ReactNode } from 'react';
import { useLocation } from 'wouter';
import { cn } from '@/lib/utils';
import { useAuth } from '@/hooks/useAuth';
import {
  CRM_NAV_ITEMS,
  selectVisibleCrmNavItems,
} from './navigationItems';

export type { CrmNavItem } from './navigationItems';
export { CRM_NAV_ITEMS, selectVisibleCrmNavItems } from './navigationItems';

interface CrmLayoutProps {
  children: ReactNode;
}

export default function CrmLayout({ children }: CrmLayoutProps) {
  const [location] = useLocation();
  const { permissions } = useAuth();

  const visibleItems = selectVisibleCrmNavItems(CRM_NAV_ITEMS, permissions);

  return (
    <div className="space-y-4">
      <nav className="flex flex-wrap gap-1 border-b pb-0" aria-label="CRM 子导航">
        {visibleItems.map((item) => {
          const active = location.startsWith(item.href);
          return (
            <a
              key={item.href}
              href={item.href}
              className={cn(
                'px-4 py-2 text-sm font-medium transition-colors',
                active
                  ? 'border-b-2 border-primary text-foreground'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              {item.label}
            </a>
          );
        })}
      </nav>
      <div>{children}</div>
    </div>
  );
}
